export default __webpack_public_path__ + "6bcaf608cfa706703bd36499c7ecdf95.svg";